export default __webpack_public_path__ + "static/media/generali.43d3ab3d.png";